import { ProductKeys, type ProductKeys1P } from '../../../../../common/constants/products';
import { createBooleanFilter } from '../../../../filters/boolean-filter';

const productKeys1P: ProductKeys1P[] = [
	ProductKeys.Jira,
	ProductKeys.JiraProductDiscovery,
	ProductKeys.JiraServiceManagement,
];

export const filter = createBooleanFilter({
	id: 'watchedByMe',
	queryParams: { key: 'jWatchedByMe' },
	products: [...productKeys1P],
	alwaysVisible: true,
	universal: false,
});
